<div class="bulk-template">
  <table mat-table [dataSource]="dataSource">
    @for (col of columns; track col) {
    <ng-container [matColumnDef]="col.key">
      <th mat-header-cell *matHeaderCellDef class="tabl-header" [style.width]="col.width" [style.textAlign]="col.align">
        {{ col.display_name }}
      </th>
      <td mat-cell *matCellDef="let element" [style.width]="col.width" [style.textAlign]="col.align">
        <div>
          @switch (col.key) { @case ('generate_template') {
          <div>
            <button mat-raised-button class="techops-global-button" (click)="generateTemplate(element)">
              Generate
            </button>
          </div>
          } @case ('post_submit') {
          <div>
            <button mat-raised-button class="techops-global-button" (click)="postSubmit(element)">Post Submit</button>
          </div>
          } @case ('lastUpdatedAt') {
          <div>
            {{ element[col.key] | date: 'MMM d, y, h:mm a' }}
          </div>
          } @case ('postSubmit_lastUpdatedAt') {
          <div>
            {{ element[col.key] | date: 'MMM d, y, h:mm a' }}
          </div>
          } @default {
          <div>{{ element[col.key] }}</div>
          } }
        </div>
      </td>
    </ng-container>
    }
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    #paginator
    [pageSizeOptions]="[10, 15, 20]"
    showFirstLastButtons
    [length]="dataSource?.data.length"
  ></mat-paginator>
</div>
